import { useEffect, useState } from 'react';

export const useClickOutside = (ref) => {
  const [clickOutside, setClickOutside] = useState(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setClickOutside(event.target);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return [clickOutside];
};
